import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  Modal,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  OutlinedInput,
  FormControl,
  Chip
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { UserContext } from "../../contexts/context-layout-user";

const GeneratorFunctionality = ({ source }) => {
  const { t } = useTranslation("global");
  const language = localStorage.getItem('i18nextLng') || 'es'
  const {
    filePath,
    setFilePath,
    projectName, setProjectName,
    caseName, setCaseName,
    periods, setPeriods,
    selectedDate, setSelectedDate,
    day, setDay
  } = useContext(UserContext);
  const [validateFilePath, setValidateFilePath] = useState("");
  const [periodSelect, setPeriodSelect] = useState(false);
  const [filePathError, setFilePathError] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const arrayPeriods = [
    "P00",
    "P01",
    "P02",
    "P03",
    "P04",
    "P05",
    "P06",
    "P07",
    "P08",
    "P09",
    "P10",
    "P11",
    "P12",
    "P13",
    "P14",
    "P15",
    "P16",
    "P17",
    "P18",
    "P19",
    "P20",
    "P21",
    "P22",
    "P23"
  ];
  const arrayDays = [
    { value: "lunes", dayEs: "Lunes", dayEn: "Monday" },
    { value: "martes", dayEs: "Martes", dayEn: "Tuesday" },
    { value: "miercoles", dayEs: "Miércoles", dayEn: "Wednesday" },
    { value: "jueves", dayEs: "Jueves", dayEn: "Thursday" },
    { value: "viernes", dayEs: "Viernes", dayEn: "Friday" },
    { value: "sabado", dayEs: "Sábado", dayEn: "Saturday" },
    { value: "domingo", dayEs: "Domingo", dayEn: "Sunday" }
  ];

  useEffect(() => {
    setPeriods(arrayPeriods);
    setValidateFilePath(filePath);
  }, []);

  const handleFileChange = (event) => {
    setValidateFilePath(event.target.value);
    const file = event.target.value;
    const fileExtension = file.split('.').pop().toLowerCase();
    if (fileExtension === 'zip' || fileExtension === 'zip"') {
      setFilePath(event.target.value);
      setFilePathError(false);
    } else {
      setFilePathError(true);
      setFilePath("");
    }
  };

  const handleProjectNameChange = (event) => {
    setProjectName(event.target.value);
  };

  const handlecaseNameChange = (event) => {
    setCaseName(event.target.value);
  }

  const handleChange = (date) => {
    setSelectedDate(date);
  };

  const selectPeriod = () => {
    const change = !periodSelect;
    setPeriodSelect(change);
    if (change) {
      setPeriods([]);
    } else {
      setPeriods(arrayPeriods);
    }
  }

  const handleChangePeriods = (event) => {
    const {
      target: { value },
    } = event;
    setPeriods(
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  const handleChangeDay = (event) => {
    setDay(event.target.value);
  };

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
      <Grid item xs={12} style={{ borderRight: '1px solid rgba(0, 0, 0, 0.12)', paddingTop: "20px", marginLeft: "10px" }}>
        <Grid container spacing={0}>
          <Grid item xs={10}>
            <Grid container direction="row" justifyContent="center" alignItems="center" style={{ height: '100%' }}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{
                  border: "2px dashed rgb(0, 0, 0)",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                  borderRadius: "30px",
                  fontSize: "15px",
                }}
              >
                <TextField
                  id="filePathInput"
                  type="text"
                  value={validateFilePath}
                  onChange={handleFileChange}
                  label={t('generator.simemem.routeFile')}
                  error={filePathError}
                  helperText={filePathError ? t('generator.simemem.errorFile') : !filePathError && validateFilePath !== '' ? t('generator.simemem.correctFile') : ''}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} style={{ padding: "10px", alignContent: 'center' }}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <InfoOutlined
                  style={{ cursor: "pointer", fontSize: "30px" }}
                  onMouseEnter={() => setOpenModal(true)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={10} style={{ marginTop: "20px" }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" style={{ width: '100%' }}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  borderRadius: "30px",
                  fontSize: "15px",
                }}
              >
                <TextField
                  id="projectName"
                  type="text"
                  label={t('generator.simemem.projectName')}
                  value={projectName}
                  onChange={handleProjectNameChange}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={10} style={{ marginTop: "20px" }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" style={{ width: '100%' }}>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                style={{
                  textAlign: "center",
                  cursor: "pointer",
                  borderRadius: "30px",
                  fontSize: "15px",
                }}
              >
                <TextField
                  id="caseName"
                  type="text"
                  label={t('generator.simemem.caseName')}
                  value={caseName}
                  onChange={handlecaseNameChange}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={10} style={{ marginTop: "20px" }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" style={{ height: '100%' }}>
              <Grid style={{ width: '100%' }}>
                {source === 0 ?
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label={t('generator.simemem.dateSelect')}
                      views={['year', 'month', 'day']}
                      value={selectedDate}
                      onChange={handleChange}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                      inputFormat="yyyy-MM-dd"
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          helperText: 'MM/DD/YYYY',
                        },
                      }}
                    />
                  </LocalizationProvider>
                  :
                  <FormControl sx={{ m: 1, width: '100%', maxWidth: '387px', margin: '0' }}>
                    <InputLabel id="demo-simple-select-label">{t('generator.xlsm.dayInfo')}</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-multiple-checkbox"
                      value={day}
                      onChange={handleChangeDay}
                      input={<OutlinedInput label={t('generator.xlsm.dayInfo')} />}
                      MenuProps={MenuProps}
                    >
                      {arrayDays.map((day) => (
                        <MenuItem key={day} value={day.value}>
                          {language === 'es' ? day.dayEs : day.dayEn}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                }
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={10} style={{ marginTop: "20px" }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" style={{ height: '100%' }}>
              <Grid>
                <FormControlLabel
                  control={<Checkbox
                    id='periods'
                    checked={periodSelect}
                    onChange={selectPeriod}
                  />}
                  label={t('generator.simemem.periodsTitle')}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={10} style={{ margin: "20px 0px" }}>
            <Grid container direction="row" justifyContent="center" alignItems="center" style={{ height: '100%' }}>
              <Grid style={{ width: '100%' }}>
                <FormControl
                  disabled={!periodSelect}
                  sx={{ m: 1, width: '100%', margin: 0 }}
                >
                  <InputLabel id="demo-multiple-chip-label">{t('generator.simemem.periods')}</InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={periods}
                    onChange={handleChangePeriods}
                    input={<OutlinedInput id="select-multiple-chip" label={t('generator.simemem.periodsTitle')} />}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {arrayPeriods.map((period) => (
                      <MenuItem key={period} value={period}>
                        <Checkbox checked={periods.includes(period)} />
                        <ListItemText primary={period} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        disableAutoFocus
      >
        <Box
          onMouseEnter={() => setOpenModal(true)}
          onMouseLeave={() => setOpenModal(false)}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            padding: 4,
            borderRadius: "10px",
          }}
        >
          <Typography variant="h6" gutterBottom>
            {t('generator.simemem.description')}
          </Typography>
          <Typography>
            <a href="https://www.xm.com.co/consumo/informes-demanda/pronostico-oficial-de-demanda-definitivo"
              target="_blank"
              rel="noopener noreferrer">
              {t('generator.simemem.link')}
            </a>
          </Typography>
        </Box>
      </Modal>
    </Grid>
  );
};

export default GeneratorFunctionality;
